import Vue from 'vue';
import axios from 'axios';

export class Veiculo {

    static create(){

        let street = {};

        street.placa = null;
        street.nomes = {
            output1: {
                nome: 'Saída 1',
                usado: true
            },
            output2: {
                nome: 'Saída 2',
                usado: false
            },
            input1: {
                nome: 'Entrada 1',
                usado: true
            },
            input2: {
                nome: 'Entrada 2',
                usado: false
            },
            input3: {
                nome: 'Entrada 3',
                usado: false
            }
        };
        street.ocultar_portal = false;
        street.desabilitar_historico_portal = false;
        street.tipo = 'car';
        street.renavan = null;
        street.bloqueado = false;
        street.chassi = null;
        street.ano = null;
        street.marca = null;
        street.telegram = true;
        street.modelo = null;
        street.cor = null;
        street.id_rastreador = null;
        street.sms_sem_transmissao = false;
        street.chamadas = false;
        street.embarcar_velocidade = false;
        street.fcm_sem_transmissao = true;
        street.sem_transmissao_tempo_maximo = 48;
        street.basico_mensal = 0;
        street.calcular_distancia_relatorio = false;
        street.sms = Veiculo.createSms();
        street.agricola_tipo = 'NORMAL';
        street.agricola_entrada_numero = 1;
        street.logistica = false;
        street.enable_bloqueio = false;
        street.id_cliente = null;
        street.apisul = false;
        street.palavra_chave = null;
        street.cliente = {
            id_cliente: null,
            nome: null
        };

        return street;
    }

    static createSms () {
        return {
            input1: false,
            input2: false,
            panic: false,
            speed: false,
            battery: false,
            garage: false,
            varea: false,
            ignon: false,
            ignoff: false,
            normal: false,
            jammer: false,
            night: false
        };
    }

    /**
     *
     * @return {Promise}
     */
    static grid(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/veiculos')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static grid2(){
        return new Promise((resolve, reject) => {
            axios.get('grid/v2/veiculos', {
                timeout: 8000
            })
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    static combo(){
        return new Promise((resolve, reject) => {
            axios.get('veiculo/combo', {
                timeout: 8000
            })
                .then((res) => resolve(res.data.veiculos))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static gridCancelados(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/v2/veiculos-cancelados')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_veiculo
     * @return {Promise}
     */
    static remove(id_veiculo){
        return Vue.http.delete('veiculo/by-pk/'+ id_veiculo);
    }

    static duplicar(id_veiculo){
        return Vue.http.post('veiculo/'+ id_veiculo + '/duplicar');
    }

    /**
     *
     * @param id_veiculo
     * @param uuid_cliente
     * @returns {Promise}
     */
    static transferir(id_veiculo, uuid_cliente){
        return Vue.http.put('veiculo/transferir', {
            cliente_uuid: uuid_cliente,
            id_veiculo: id_veiculo
        });
    }

    static darAcesso(json){
        return Vue.http.post('veiculo/dar-acesso', json);
    }

    static darAcessoV2(json){
        return Vue.http.post('v2/veiculo/dar-acesso', json);
    }

    static enableBlock(json){
        return Vue.http.post('veiculo/acesso-by-login/'+ json.id_login_site + '/enable-block', json);
    }

    /**
     *
     * @param id_veiculo
     * @returns {Promise<{
                    id: number,
                    obs: string,
                    finalizado: boolean,
                    data_termino: string,
                    tipo: string
                }[]>}
     */
    static byPK(id_veiculo){
        return new Promise((ok, fail) => {
            Vue.http.get('veiculo/by-pk/'+ id_veiculo)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static ordensServico(id_veiculo){
        return new Promise((ok, fail) => {
            axios.get('veiculo/'+ id_veiculo + '/ordem-servico')
                .then((res) => ok(res.data.ordens))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_veiculo
     * @returns {Promise}
     */
    static areasSeguras(id_veiculo){
        return new Promise((ok, fail) => {
            Vue.http.get('veiculo/' + id_veiculo + '/areas-seguras')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise<any>}
     */
    static allMaps(){
        return new Promise((ok, fail) => {
            Vue.http.get('veiculo/all-map')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param placa
     * @returns {Promise}
     */
    static byPlaca(placa){
        return new Promise((ok, fail) => {
            Vue.http.get('veiculo/by-placa/'+ placa)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     * @deprecated
     */
    static byCliente(uuid){
        return new Promise((ok, fail) => {
            Vue.http.get('clientes/'+ uuid + '/veiculos')
                .then((res) => ok(res.data.veiculos))
                .catch((err) => fail(err));
        });
    }

    static vehiclesByCliente(id_cliente){
        return new Promise((ok, fail) => {
            Vue.http.get('v1/customers/'+ id_cliente + '/vehicles')
                .then((res) => ok(res.data.veiculos))
                .catch((err) => fail(err));
        });
    }


    /**
     *
     * @param id_cliente
     * @return {Promise}
     */
    static acessoByCliente(id_cliente){
        return new Promise((ok, fail) => {
            Vue.http.get('veiculo/acesso-by-cliente/'+ id_cliente)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     * @param id_login
     * @return {Promise}
     */
    static acessoByLogin(id_login){
        return new Promise((ok, fail) => {
            Vue.http.get('veiculo/acesso-by-login/'+ id_login)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     * @param id_login
     * @param idVeiculo
     * @return {Promise}
     */
    static removeAcessoByLogin(id_login, idVeiculo){
        return new Promise((ok, fail) => {
            Vue.http.delete('veiculo/acesso-by-login/'+ id_login + '/' + idVeiculo)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_veiculo
     * @param status
     * @return {Promise<any>}
     */
    static bloquear(id_veiculo, status){
        return new Promise((ok, fail) => {
            Vue
                .http
                .put('veiculo/bloqueio-financeiro/'+ id_veiculo, {
                    bloqueado: status
                })
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param uuid
     * @param status
     * @return {Promise<any>}
     */
    static roubado(uuid, status){
        return new Promise((ok, fail) => {
            if (status) {
                Vue.http.put('veiculos/habilitar-roubo/'+ uuid)
                    .then((res) => ok(res.data)).catch((err) => fail(err));
            } else {
                Vue.http.delete('veiculos/habilitar-roubo/'+ uuid)
                    .then((res) => ok(res.data)).catch((err) => fail(err));
            }
        });
    }

    /**
     *
     * @param uuid
     * @param status
     * @param termino
     * @return {Promise<any>}
     */
    static oficina(uuid, status, termino, txt){
        return new Promise((ok, fail) => {
            if (status) {
                Vue.http.put('veiculos/oficina/'+ uuid, {
                    termino_oficina: termino,
                    oficina_txt: txt
                }).then((res) => ok(res.data)).catch((err) => fail(err));
            } else {
                Vue.http.delete('veiculos/oficina/'+ uuid)
                    .then((res) => ok(res.data)).catch((err) => fail(err));
            }
        });
    }

    /**
     *
     * @return {Promise<any>}
     */
    static direcaoNoturna(veiculo){
        return new Promise((ok, fail) => {
            Vue.http.put('veiculos/direcao-noturna/'+ veiculo.uuid, {
                habilitar_direcao_noturna: veiculo.habilitar_direcao_noturna,
                hora_inicial_noturno: veiculo.hora_inicial_noturno,
                hora_final_noturno: veiculo.hora_final_noturno,
                bloqueio_noturno: veiculo.bloqueio_noturno
            }).then((res) => ok(res.data)).catch((err) => fail(err));
        });
    }

    /**
     *
     * @param uuid
     * @param status
     * @param termino
     * @param txt
     * @return {Promise<any>}
     */
    static manutencao(uuid, status, termino, txt){
        return new Promise((ok, fail) => {
            if (status) {
                Vue.http.put('veiculos/manutencao/'+ uuid, {
                    termino_sinistro: termino,
                    sinistro_txt: txt
                }).then((res) => ok(res.data)).catch((err) => fail(err));
            } else {
                Vue.http.delete('veiculos/manutencao/'+ uuid)
                    .then((res) => ok(res.data)).catch((err) => fail(err));
            }
        });
    }

    /**
     *
     * @param id_veiculo
     * @param status
     * @param {Object} [extras] — ex.: ordem_servico para retirada no cancelamento
     * @return {Promise<any>}
     */
    static cancelar(id_veiculo, status, extras = {}){
        return new Promise((ok, fail) => {
            Vue
                .http
                .put('veiculo/cancelar/'+ id_veiculo, {
                    cancelado: status,
                    ...extras
                })
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param json
     * @returns {Promise}
     */
    static save(json){
        return new Promise((ok, fail) => {

            let promise = null;

            if (json.id_veiculo){
                promise = Vue.http.put('veiculo/by-pk/'+ json.id_veiculo, json);
            } else {
                promise = Vue.http.post('veiculo/by-pk/'+ json.id_veiculo, json);
            }

            promise
                .then((res) => ok(res.data))
                .catch((err) => fail(err));

        });
    }

}
